import { shipmentEventType, warehouseEventType } from '#type';

export const alertEventIds = [
  shipmentEventType.TRIGGER_ALERT,
  warehouseEventType.TRIGGER_APPLIANCE_GROUP_ALERT
];
